// extracted by mini-css-extract-plugin
export var aircallIframe = "_do-3";
export var fabContainer = "_do-5";
export var fabRinging = "_do-6";
export var loadingOverlay = "_do-4";
export var pulse = "_do-7";
export var widgetContent = "_do-2";
export var widgetPanel = "_do-0";
export var widgetPanelExpanded = "_do-1";